<app-server-grid [configuration]="invoiceGridConfiguration"
                 [(request)]="invoiceGridRequest"
                 [refresh]="refreshGrid"
                 [(selection)]="invoiceGridSelection"
                 [filterTemplate]="filterForm"
                 [actions]="bulkActions"
                 [actionTemplate]="approvalCenterActionTemplate"
                 (dataLoaded)="onGridDataLoaded($event)">

  <ng-template #chaseIdColumn let-rowData>
    <app-chase-grid-chase-id [isOverreadFeedbackEmpty]="true" [isCurrentUserAbstractorForOverreadFeedback]="false"
      [data]="rowData" chaseIdUrl="/members/chase/:chaseId"></app-chase-grid-chase-id>
  </ng-template>

  <ng-template #approvalCenterActionTemplate
               let-rowData let-localActionPopover="actionPopover">
    <div class="action-template-container">
      <app-button *ngFor="let action of bulkActions; trackBy: trackByIndex"
                  [text]="action.name"
                  (onClick)="action.action(rowData); localActionPopover.hide();" [disabled]="isEditDisabled(rowData.invoiceType,action.name) || isBulkActionLoading"></app-button>
    </div>
  </ng-template>
  <ng-template #filterForm
               let-form>
    <app-tab-menu orientation="left">

      <app-tab-panel header="Invoice ID">
        <div class="p-col-12 p-md-12 p-lg-12">
          <form-factory [formGroup]="form"
                        [model]="invoiceIdInput"></form-factory>
        </div>
      </app-tab-panel>

      <app-tab-panel header="Invoice Number">
        <div class="p-col-12 p-md-12 p-lg-12">
          <form-factory [formGroup]="form"
                        [model]="invoiceNumberInput"></form-factory>
        </div>
      </app-tab-panel>

      <app-tab-panel header="Chase ID">
        <div class="p-col-12 p-md-12 p-lg-12">
          <form-factory [formGroup]="form"
                        [model]="chaseIdInput"></form-factory>
        </div>
      </app-tab-panel>

      <app-tab-panel class="checkbox-group__halves" header="Project(s)">
        <div class="p-col-12 p-md-12 p-lg-12">
          <form-factory [formGroup]="form"
                        [model]="projectIdsAsCsvInput"></form-factory>
        </div>
      </app-tab-panel>

      <app-tab-panel header="AID">
        <div class="p-col-12 p-md-12 p-lg-12">
          <form-factory [formGroup]="form"
                        [model]="addressIdInput"></form-factory>
        </div>
      </app-tab-panel>

      <app-tab-panel class="checkbox-group__halves" header="Vendor">
        <div class="p-col-12 p-md-12 p-lg-12">
          <form-factory [formGroup]="form"
                        [model]="vendorIdsAsCsvInput"></form-factory>
        </div>
      </app-tab-panel>

      <app-tab-panel class="checkbox-group__halves" header="Invoice Type">
        <div class="p-col-12 p-md-12 p-lg-12">
          <form-factory [formGroup]="form"
                        [model]="invoiceTypeIdsAsCsvInput"></form-factory>
        </div>
      </app-tab-panel>

      <app-tab-panel class="checkbox-group__halves" header="Payment Type" *ngIf="!isApprovalCenterGrid">
        <div class="p-col-12 p-md-12 p-lg-12">
          <form-factory [formGroup]="form"
                        [model]="paymentTypeIdsAsCsvInput"></form-factory>
        </div>
      </app-tab-panel>

      <app-tab-panel header="Amount Per Chase">
        <div class="p-col-12 p-md-12 p-lg-12">
          <form-factory [formGroup]="form"
                        [model]="amountInput"></form-factory>
        </div>
      </app-tab-panel>

      <!--TODO: Code is commented as we don't have exact status filter for now.-->
      <!--<app-tab-panel class="checkbox-group__halves" header="Status">
        <div class="p-col-12 p-md-12 p-lg-12">
          <form-factory [formGroup]="form"
                        [model]="statusIdsAsCsvInput"></form-factory>
        </div>
      </app-tab-panel>-->

    </app-tab-menu>
  </ng-template>

</app-server-grid>


<app-confirmation-modal [(visible)]="isConfirmationModalVisible"
                        header="{{confirmationModalHeader}}"
                        (onYes)="continueAction()"
                        (onCancel)="cancelAction()" class="confirmation-modal">
  {{confirmationModalText}}
</app-confirmation-modal>
<app-modal [(visible)]="showZipFileNameModal"
           header="Zip Information">
  <form>
    <div class="p-grid p-fluid basic-filter">
      <div class="p-col-12 p-md-12 p-lg-12">
        <form-factory class="input"
                      [formGroup]="invoiceDownloadForm"
                      [model]="getZipFileName()">
        </form-factory>
       </div>
    </div>
  </form>
  <footer>
    <app-button class="header-button"
                text="Continue"
                (onClick)="zipFileNameChanged()">

    </app-button>
  </footer>
</app-modal> 
